































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import sceneFragment from "@/fragments/scene";
import actorFragment from "@/fragments/actor";
import imageFragment from "@/fragments/image";
import movieFragment from "@/fragments/movie";
import studioFragment from "@/fragments/studio";
import { actorModule } from "@/store/actor";
import SceneCard from "@/components/SceneCard.vue";
import moment from "moment";
import LabelSelector from "@/components/LabelSelector.vue";
import Lightbox from "@/components/Lightbox.vue";
import MovieCard from "@/components/MovieCard.vue";
import ImageCard from "@/components/ImageCard.vue";
import InfiniteLoading from "vue-infinite-loading";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import ImageUploader from "@/components/ImageUploader.vue";
import IScene from "@/types/scene";
import IMovie from "@/types/movie";
import IImage from "@/types/image";
import ILabel from "@/types/label";
import { contextModule } from "@/store/context";
import CustomFieldSelector from "@/components/CustomFieldSelector.vue";
import Collabs from "@/components/Collabs.vue";
import { ICollabActor } from "@/types/actor";

interface ICropCoordinates {
  left: number;
  top: number;
  width: number;
  height: number;
}

interface ICropResult {
  coordinates: ICropCoordinates;
}

@Component({
  components: {
    SceneCard,
    LabelSelector,
    Lightbox,
    ImageCard,
    InfiniteLoading,
    Cropper,
    ImageUploader,
    CustomFieldSelector,
    MovieCard,
    CircleStencil,
    Collabs,
  },
  beforeRouteLeave(_to, _from, next) {
    actorModule.setCurrent(null);
    next();
  },
})
export default class ActorDetails extends Vue {
  scenes = [] as IScene[];
  movies = [] as IMovie[];
  images = [] as IImage[];
  collabs = [] as ICollabActor[];
  lightboxIndex = null as number | null;

  activeTab = 0;

  labelSelectorDialog = false;
  allLabels = [] as ILabel[];
  selectedLabels = [] as number[];
  labelEditLoader = false;

  scenePage = 0;
  sceneInfiniteId = 0;

  infiniteId = 0;
  page = 0;

  imageDialog = false;

  avatarDialog = false;
  avatarLoader = false;
  avatarDisplay = null as string | null;
  selectedAvatar = null as File | null;
  avatarCrop: ICropCoordinates = { left: 0, top: 0, width: 0, height: 0 };

  thumbnailDialog = false;
  thumbnailLoader = false;
  thumbnailDisplay = null as string | null;
  selectedThumbnail = null as File | null;
  thumbnailCrop: ICropCoordinates = { left: 0, top: 0, width: 0, height: 0 };

  altThumbnailDialog = false;
  altThumbnailLoader = false;
  altThumbnailDisplay = null as string | null;
  selectedAltThumbnail = null as File | null;
  altThumbnailCrop: ICropCoordinates = { left: 0, top: 0, width: 0, height: 0 };

  heroDialog = false;
  heroLoader = false;
  heroDisplay = null as string | null;
  selectedHero = null as File | null;
  heroCrop: ICropCoordinates = { left: 0, top: 0, width: 0, height: 0 };

  uploadDialog = false;
  isUploading = false;

  editCustomFields = {} as any;
  hasUpdatedFields = false;

  sceneLoader = false;
  pluginLoader = false;
  attachUnmatchedScenesLoader = false;

  labelSearchQuery = "";

  get avatarColor() {
    if (!this.currentActor) return "#ffffff";
    if (!this.currentActor.avatar) return "#ffffff";
    return this.currentActor.avatar.color || "#ffffff";
  }

  get avatar() {
    if (!this.currentActor) return null;
    if (!this.currentActor.avatar) return null;
    return `${serverBase}/media/image/${
      this.currentActor.avatar._id
    }?password=${localStorage.getItem("password")}`;
  }

  get heroImage() {
    if (!this.currentActor) return null;
    if (!this.currentActor.hero) return null;
    return `${serverBase}/media/image/${this.currentActor.hero._id}?password=${localStorage.getItem(
      "password"
    )}`;
  }

  sceneInfiniteHandler($state) {
    this.fetchScenePage().then((items) => {
      if (items.length) {
        this.scenePage++;
        this.scenes.push(...items);
        $state.loaded();
      } else {
        $state.complete();
      }
    });
  }

  async fetchScenePage() {
    try {
      if (!this.currentActor) return;

      const result = await ApolloClient.query({
        query: gql`
          query($query: SceneSearchQuery!) {
            getScenes(query: $query) {
              items {
                ...SceneFragment
                actors {
                  ...ActorFragment
                }
                studio {
                  ...StudioFragment
                }
              }
            }
          }
          ${sceneFragment}
          ${actorFragment}
          ${studioFragment}
        `,
        variables: {
          query: {
            query: "",
            actors: [this.currentActor._id],
            page: this.scenePage,
            sortDir: "desc",
            sortBy: "addedOn",
          },
        },
      });

      return result.data.getScenes.items;
    } catch (err) {
      throw err;
    }
  }

  runPlugins() {
    if (!this.currentActor) return;

    this.pluginLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($id: String!) {
          runActorPlugins(id: $id) {
            ...ActorFragment
            numScenes
            labels {
              _id
              name
            }
            thumbnail {
              _id
              color
            }
            altThumbnail {
              _id
            }
            watches
            hero {
              _id
              color
            }
            avatar {
              _id
            }
          }
        }
        ${actorFragment}
      `,
      variables: {
        id: this.currentActor._id,
      },
    })
      .then((res) => {
        actorModule.setCurrent(res.data.runActorPlugins);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.pluginLoader = false;
      });
  }

  attachUnmatchedScenes() {
    if (!this.currentActor) return;

    this.attachUnmatchedScenesLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($id: String!) {
          attachActorToUnmatchedScenes(id: $id) {
            ...ActorFragment
            numScenes
            labels {
              _id
              name
            }
            thumbnail {
              _id
              color
            }
            altThumbnail {
              _id
            }
            watches
            hero {
              _id
              color
            }
            avatar {
              _id
            }
          }
        }
        ${actorFragment}
      `,
      variables: {
        id: this.currentActor._id,
      },
    })
      .then((res) => {
        actorModule.setCurrent(res.data.attachActorToUnmatchedScenes);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.attachUnmatchedScenesLoader = false;
      });
  }

  updateCustomFields() {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            customFields
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          customFields: this.editCustomFields,
        },
      },
    })
      .then((res) => {
        actorModule.setCustomFields(res.data.updateActors[0].customFields);
        this.hasUpdatedFields = false;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  get aspectRatio() {
    return contextModule.actorAspectRatio;
  }

  openUploadDialog() {
    this.uploadDialog = true;
  }

  changeAvatarCrop(crop: ICropResult) {
    this.avatarCrop = {
      left: Math.round(crop.coordinates.left),
      top: Math.round(crop.coordinates.top),
      width: Math.round(crop.coordinates.width),
      height: Math.round(crop.coordinates.height),
    };
  }

  changeThumbnailCrop(crop: ICropResult) {
    this.thumbnailCrop = {
      left: Math.round(crop.coordinates.left),
      top: Math.round(crop.coordinates.top),
      width: Math.round(crop.coordinates.width),
      height: Math.round(crop.coordinates.height),
    };
  }

  changeAltThumbnailCrop(crop: ICropResult) {
    this.altThumbnailCrop = {
      left: Math.round(crop.coordinates.left),
      top: Math.round(crop.coordinates.top),
      width: Math.round(crop.coordinates.width),
      height: Math.round(crop.coordinates.height),
    };
  }

  changeHeroCrop(crop: ICropResult) {
    this.heroCrop = {
      left: Math.round(crop.coordinates.left),
      top: Math.round(crop.coordinates.top),
      width: Math.round(crop.coordinates.width),
      height: Math.round(crop.coordinates.height),
    };
  }

  readImage(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) resolve(reader.result.toString());
        else reject("File error");
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async readAvatar(file: File) {
    if (file) this.avatarDisplay = await this.readImage(file);
  }

  async readThumbnail(file: File) {
    if (file) this.thumbnailDisplay = await this.readImage(file);
  }

  async readAltThumbnail(file: File) {
    if (file) this.altThumbnailDisplay = await this.readImage(file);
  }

  async readHero(file: File) {
    if (file) this.heroDisplay = await this.readImage(file);
  }

  uploadAvatar() {
    if (!this.currentActor) return;

    this.avatarLoader = true;

    console.log("Uploading avatar...");

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $file: Upload!
          $name: String
          $crop: Crop
          $actors: [String!]
          $labels: [String!]
          $compress: Boolean
        ) {
          uploadImage(
            file: $file
            name: $name
            crop: $crop
            actors: $actors
            labels: $labels
            compress: $compress
          ) {
            ...ImageFragment
            actors {
              ...ActorFragment
            }
            scene {
              _id
              name
            }
          }
        }
        ${imageFragment}
        ${actorFragment}
      `,
      variables: {
        file: this.selectedAvatar,
        name: this.currentActor.name + " (avatar)",
        actors: [this.currentActor._id],
        labels: this.currentActor.labels.map((a) => a._id),
        crop: {
          left: this.avatarCrop.left,
          top: this.avatarCrop.top,
          width: this.avatarCrop.width,
          height: this.avatarCrop.height,
        },
        compress: true,
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsAvatar(image._id);
        this.avatarDialog = false;
        this.avatarDisplay = null;
        this.selectedAvatar = null;
      })
      .finally(() => {
        this.avatarLoader = false;
      });
  }

  uploadHero() {
    if (!this.currentActor) return;

    this.heroLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $file: Upload!
          $name: String
          $crop: Crop
          $actors: [String!]
          $labels: [String!]
          $compress: Boolean
        ) {
          uploadImage(
            file: $file
            name: $name
            crop: $crop
            actors: $actors
            labels: $labels
            compress: $compress
          ) {
            ...ImageFragment
            actors {
              ...ActorFragment
            }
            scene {
              _id
              name
            }
          }
        }
        ${imageFragment}
        ${actorFragment}
      `,
      variables: {
        file: this.selectedHero,
        name: this.currentActor.name + " (hero image)",
        actors: [this.currentActor._id],
        labels: this.currentActor.labels.map((a) => a._id),
        crop: {
          left: this.heroCrop.left,
          top: this.heroCrop.top,
          width: this.heroCrop.width,
          height: this.heroCrop.height,
        },
        compress: false,
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsHero(image._id);
        this.heroDialog = false;
        this.heroDisplay = null;
        this.selectedHero = null;
      })
      .finally(() => {
        this.heroLoader = false;
      });
  }

  uploadAltThumbnail() {
    if (!this.currentActor) return;

    this.altThumbnailLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $file: Upload!
          $name: String
          $crop: Crop
          $actors: [String!]
          $labels: [String!]
          $compress: Boolean
        ) {
          uploadImage(
            file: $file
            name: $name
            crop: $crop
            actors: $actors
            labels: $labels
            compress: $compress
          ) {
            ...ImageFragment
            actors {
              ...ActorFragment
            }
            scene {
              _id
              name
            }
          }
        }
        ${imageFragment}
        ${actorFragment}
      `,
      variables: {
        file: this.selectedAltThumbnail,
        name: this.currentActor.name + " (alt. thumbnail)",
        actors: [this.currentActor._id],
        labels: this.currentActor.labels.map((a) => a._id),
        crop: {
          left: this.altThumbnailCrop.left,
          top: this.altThumbnailCrop.top,
          width: this.altThumbnailCrop.width,
          height: this.altThumbnailCrop.height,
        },
        compress: true,
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsAltThumbnail(image._id);
        this.altThumbnailDialog = false;
        this.altThumbnailDisplay = null;
        this.selectedAltThumbnail = null;
      })
      .finally(() => {
        this.altThumbnailLoader = false;
      });
  }

  uploadThumbnail() {
    if (!this.currentActor) return;

    this.thumbnailLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $file: Upload!
          $name: String
          $crop: Crop
          $actors: [String!]
          $labels: [String!]
          $compress: Boolean
        ) {
          uploadImage(
            file: $file
            name: $name
            crop: $crop
            actors: $actors
            labels: $labels
            compress: $compress
          ) {
            ...ImageFragment
            actors {
              ...ActorFragment
            }
            scene {
              _id
              name
            }
          }
        }
        ${imageFragment}
        ${actorFragment}
      `,
      variables: {
        file: this.selectedThumbnail,
        name: this.currentActor.name + " (thumbnail)",
        actors: [this.currentActor._id],
        labels: this.currentActor.labels.map((a) => a._id),
        crop: {
          left: this.thumbnailCrop.left,
          top: this.thumbnailCrop.top,
          width: this.thumbnailCrop.width,
          height: this.thumbnailCrop.height,
        },
        compress: true,
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsThumbnail(image._id);
        this.thumbnailDialog = false;
        this.thumbnailDisplay = null;
        this.selectedThumbnail = null;
      })
      .finally(() => {
        this.thumbnailLoader = false;
      });
  }

  openAltThumbnailDialog() {
    this.altThumbnailDialog = true;
  }

  openThumbnailDialog() {
    this.thumbnailDialog = true;
  }

  removeImage(index: number) {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeImages(ids: $ids)
        }
      `,
      variables: {
        ids: [this.images[index]._id],
      },
    })
      .then((res) => {
        this.images.splice(index, 1);
        this.lightboxIndex = null;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }

  async fetchPage() {
    if (!this.currentActor) return;

    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: ImageSearchQuery!) {
            getImages(query: $query) {
              items {
                ...ImageFragment
                labels {
                  _id
                  name
                }
                studio {
                  _id
                  name
                }
                actors {
                  ...ActorFragment
                  avatar {
                    _id
                    color
                  }
                }
                scene {
                  _id
                  name
                }
              }
            }
          }
          ${imageFragment}
          ${actorFragment}
        `,
        variables: {
          query: {
            sortDir: "asc",
            sortBy: "addedOn",
            page: this.page,
            actors: [this.currentActor._id],
          },
        },
      });

      return result.data.getImages.items;
    } catch (err) {
      throw err;
    }
  }

  infiniteHandler($state) {
    this.fetchPage().then((items) => {
      if (items.length) {
        this.page++;
        this.images.push(...items);
        $state.loaded();
      } else {
        $state.complete();
      }
    });
  }

  updateImage({ index, key, value }: { index: number; key: string; value: any }) {
    const images = this.images[index];
    images[key] = value;
    Vue.set(this.images, index, images);
  }

  get currentActor() {
    return actorModule.current;
  }

  setAsAvatar(id: string | null) {
    if (!this.currentActor) return;

    console.log("Set image as avatar...");

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            avatar {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          avatar: id,
        },
      },
    })
      .then((res) => {
        actorModule.setAvatar(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setAsHero(id: string | null) {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            hero {
              _id
              color
            }
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          hero: id,
        },
      },
    })
      .then((res) => {
        actorModule.setHero(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setAsAltThumbnail(id: string | null) {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            altThumbnail {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          altThumbnail: id,
        },
      },
    })
      .then((res) => {
        actorModule.setAltThumbnail(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setAsThumbnail(id: string | null) {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            thumbnail {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          thumbnail: id,
        },
      },
    })
      .then((res) => {
        actorModule.setThumbnail(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  updateActorLabels(labels: ILabel[]) {
    if (!this.currentActor) return Promise.reject();

    return ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            labels {
              _id
              name
              aliases
            }
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          labels: labels.map((l) => l._id),
        },
      },
    })
      .then((res) => {
        actorModule.setLabels(res.data.updateActors[0].labels);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  editLabels() {
    if (!this.currentActor) return Promise.reject();

    this.labelEditLoader = true;
    return this.updateActorLabels(this.selectedLabels.map((i) => this.allLabels[i]))
      .then((res) => {
        this.labelSelectorDialog = false;
      })
      .finally(() => {
        this.labelEditLoader = false;
      });
  }

  openLabelSelector() {
    if (!this.currentActor) return;

    if (!this.allLabels.length) {
      ApolloClient.query({
        query: gql`
          {
            getLabels {
              _id
              name
              aliases
            }
          }
        `,
      })
        .then((res) => {
          if (!this.currentActor) return;

          this.allLabels = res.data.getLabels;
          this.selectedLabels = this.currentActor.labels.map((l) =>
            this.allLabels.findIndex((k) => k._id == l._id)
          );
          this.labelSelectorDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.labelSelectorDialog = true;
    }
  }

  imageLink(image: any) {
    return `${serverBase}/media/image/${image._id}?password=${localStorage.getItem("password")}`;
  }

  rate(rating: number) {
    if (!this.currentActor) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: ActorUpdateOpts!) {
          updateActors(ids: $ids, opts: $opts) {
            rating
          }
        }
      `,
      variables: {
        ids: [this.currentActor._id],
        opts: {
          rating,
        },
      },
    }).then((res) => {
      actorModule.setRating(rating);
    });
  }

  get thumbnail() {
    if (this.currentActor && this.currentActor.thumbnail)
      return `${serverBase}/media/image/${
        this.currentActor.thumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return `${serverBase}/broken`;
  }

  get altThumbnail() {
    if (this.currentActor && this.currentActor.altThumbnail)
      return `${serverBase}/media/image/${
        this.currentActor.altThumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return null;
  }

  @Watch("$route.params.id")
  onRouteChange() {
    actorModule.setCurrent(null);
    this.images = [];
    this.scenes = [];
    this.movies = [];
    this.collabs = [];
    this.selectedLabels = [];
    this.page = 0;
    this.scenePage = 0;
    this.onLoad();
    this.loadCollabs();
    this.loadMovies();
  }

  loadMovies() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getActorById(id: $id) {
            movies {
              ...MovieFragment
              actors {
                ...ActorFragment
              }
              scenes {
                ...SceneFragment
              }
            }
          }
        }
        ${sceneFragment}
        ${actorFragment}
        ${movieFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      this.movies = res.data.getActorById.movies;
    });
  }

  loadCollabs() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getActorById(id: $id) {
            collabs {
              _id
              name
              thumbnail {
                _id
              }
              avatar {
                _id
                color
              }
            }
          }
        }
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      this.collabs = res.data.getActorById.collabs;
    });
  }

  onLoad() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getActorById(id: $id) {
            ...ActorFragment
            numScenes
            labels {
              _id
              name
            }
            thumbnail {
              _id
              color
            }
            altThumbnail {
              _id
            }
            watches
            hero {
              _id
              color
            }
            avatar {
              _id
              color
            }
          }
        }
        ${actorFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      /* console.log(this.$store.state);
      console.log(actorModule); */
      // this.$store.commit("actor/setCurrent", res.data.getActorById);
      actorModule.setCurrent(res.data.getActorById);
      this.editCustomFields = res.data.getActorById.customFields;
    });
  }

  beforeMount() {
    this.onLoad();
    this.loadCollabs();
    this.loadMovies();
  }

  mounted() {
    /* window.addEventListener("keydown", ev => {
      if (ev.keyCode >= 48 && ev.keyCode <= 53) {
        const rating = ev.keyCode - 48;
        this.rate(rating);
      } else if (ev.keyCode >= 96 && ev.keyCode <= 101) {
        const rating = ev.keyCode - 96;
        this.rate(rating);
      }
    }); */
  }
}
